import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { fetchUsuario } from '../../actions/usuariosActions';
import { postUser } from '../../api/axios';
import PasswordValidation from "./PasswordValidation";
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import { DropDownArrow, customStyle } from "../../template/CustomStyle";
import { isEmail } from '../../utilities/formatString';
import { toast } from 'react-toastify';
import { encryptPassword } from '../../utilities/encryptPassword';
import { withNavigation } from '../General/withNavigation';
import '../General/AdminListCard.css';

function toastErroresApi(errs) {
    if (!Array.isArray(errs) || !errs.length) return false;
    errs.forEach((e) => {
        if (e && typeof e === 'object' && ('item1' in e || 'item2' in e)) {
            const msg = [e.item1, e.item2].filter(Boolean).join(' — ');
            if (msg) toast.warn(msg);
        } else if (typeof e === 'string') toast.warn(e);
        else if (e != null) toast.warn(String(e));
    });
    return true;
}

class UserNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idSeller: this.props.idSeller,
            password: "",
            confirmarPassword: "",
            passValidation: false,
            usuario: "",
            email: "",
            usuarioError: true,
            showSpinner: false,
            tipoUsuario: { value: null, label: null },
            idProveedor: "",
            showPassword: false,
            showConfirmPassword: false
        };
        this.tiposUsuario = [
            { value: 1, label: "Category" },
            { value: 3, label: "Seller Admin" },
            { value: 4, label: "Seller" },
            { value: 6, label: "Solo Lectura" },
            { value: 7, label: "Proveedor" }
        ];
        this.emailUsuarioInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.props.userType.isAdminMod) {
            this.setState({ tipoUsuario: this.tiposUsuario[this.props.location.state?.dropdownSelect ?? 0] });
        } else if (this.props.userType.isSellerAdmin) {
            this.setState({ tipoUsuario: { value: 4, label: "Seller" } });
        } else {
            this.setState({ tipoUsuario: { value: 4, label: "Seller" } });
        }

        if (this.emailUsuarioInputRef.current) {
            this.emailUsuarioInputRef.current.focus();
        }
    }

    componentWillReceiveProps() {
        this.setState({ email: this.props.usuario.email, usuario: this.props.usuario.nombreUsuario })
    }


    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmarPassword = (e) => {
        const { value } = e.target;
        this.setState({
            usuarioError: value !== this.state.password,
            confirmarPassword: value
        });
    }

    myChangeHandler = (e) => {
    const { name, value } = e.target;

    const cleanValue =
        name === "email" || name === "usuario"
            ? value.trimStart()
            : value;

    this.setState({ [name]: cleanValue });
};

    selectTipoUsuarioHandler = (selectedOption) => {
        this.setState({
            tipoUsuario: selectedOption ?? { value: null, label: null }
        });
    }

    handleChangeImporte = (e) => {
        const { value } = e.target;
        this.setState({ idProveedor: parseInt(value) });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        if (!isEmail(this.state.email)) {
            toast.warn("Mail incorrecto");
            return;
        }

        if (this.state.usuario == "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        if (this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        if (!this.state.passValidation) {
            toast.warn("La contraseña no cumple con los requisitos");
            return;
        }

        const tipoSel = this.state.tipoUsuario;
        const tipoValor = tipoSel && typeof tipoSel === 'object' ? tipoSel.value : null;
        if (tipoValor == null) {
            toast.warn("Seleccione un tipo de usuario");
            return;
        }

        if (tipoValor === 7) {
            if (this.state.idProveedor === "" || this.state.idProveedor == null) {
                toast.warn("Ingrese un id de proveedor");
                return;
            }
        }

        this.setState({ showSpinner: true });

        let usuario;
        try {
            usuario = {
                idSeller: this.props.idSeller,
                password: encryptPassword(this.state.password),
                usuario: this.state.usuario.trim(),
                email: this.state.email,
                enviarEmail: true,
                tipoUsuario: tipoValor,
                idUsuario: this.props.idUsuario,
                idProveedor: tipoValor === 7 ? this.state.idProveedor : null,
            };
        } catch (e) {
            this.setState({ showSpinner: false });
            toast.error(e?.message || "Error al preparar el usuario");
            return;
        }

        let usuarios = postUser(usuario);

        usuarios.then(res => {
            toast.success("Usuario agregado exitosamente");
            this.goBack();
        }).catch(err => {
            const errores = err?.response?.data?.errores;
            if (toastErroresApi(errores)) return;
            const msg = err?.response?.data?.mensaje || err?.message;
            toast.error(msg || "No pudo crearse");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    goBack = () => {
        window.history.go(-1);
    }

    togglePasswordVisibility = () => {
        if (!this.state.password || this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    toggleConfirmPasswordVisibility = () => {
        if (!this.state.confirmarPassword || this.state.confirmarPassword.length === 0) {
            toast.warn("Confirme contraseña");
            return;
        }
        this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));
    };

    render() {
        const IconEye = (isHidden) => (
            <i className={`me-1 mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px text-dark`} />
        );

        return (
            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <GoBackArrow />
                            <div>
                                <h4 className="mb-0 text-body fw-semibold">Crear usuario</h4>
                                <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                                    Completá los datos y asigná el tipo de usuario correspondiente.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="px-4 pb-4 pt-2">
                        <form className="form-material" onSubmit={this.onSubmit}>
                            <div className="row g-3">
                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label className="label-oscura">Email</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.email}
                                onChange={this.myChangeHandler}
                                placeholder="usuario@dominio.com"
                                name="email"
                                ref={this.emailUsuarioInputRef}
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label className="label-oscura">Nombre de usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.usuario}
                                onChange={this.myChangeHandler}
                                placeholder="nombreUsuario"
                                name="usuario"
                                maxLength="40"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label className="label-oscura">Contraseña</label>
                            <div className="input-group">
                                <input
                                    type={this.state.showPassword ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    value={this.state.password}
                                    onChange={this.myChangeHandler}
                                    autoComplete="new-password"
                                />
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={this.togglePasswordVisibility}
                                >
                                    {IconEye(this.state.showPassword)}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label className="label-oscura">Confirmar contraseña</label>
                            <div className="input-group">
                                <input
                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                    className={`form-control ${this.state.usuarioError ? "warning-input" : ""}`}
                                    value={this.state.confirmarPassword}
                                    onChange={this.confirmarPassword}
                                    maxLength="12"
                                />
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={this.toggleConfirmPasswordVisibility}
                                >
                                    {IconEye(this.state.showConfirmPassword)}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 d-inline">
                        <label className="label-oscura" htmlFor="passwordValidation">Requisitos de contraseña</label>
                        <PasswordValidation
                            password={this.state.password}
                            isValidPassword={this.handlePassValidation}
                        />
                    </div>

                    {(this.props.userType.isAdminMod || this.props.userType.isSellerAdmin) &&
                        <div className="col-12 col-sm-3">
                            <label className="label-oscura">Tipo Usuario</label>
                            <Select
                                name="tipoUsuario"
                                value={this.state.tipoUsuario}
                                options={
                                    this.props.userType.isAdminMod ? (
                                        (this.props.location.state?.dropdownSelect === 2)
                                            ? this.tiposUsuario.filter(t => t.value === 7)
                                            : this.tiposUsuario.filter(t => t.value === 1 || t.value === 6)
                                    ) : this.tiposUsuario.filter(t => t.value === 3 || t.value === 4)
                                }
                                onChange={this.selectTipoUsuarioHandler}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                            />
                        </div>
                    }

                    {this.state.tipoUsuario.value === 7 &&
                        <div className="col-12 col-sm-3">
                            <label className="label-oscura" htmlFor="idProveedor">Id Proveedor</label>
                            <input
                                type="number"
                                name="idProveedor"
                                id="idProveedor"
                                aria-label="idProveedor"
                                className="form-control"
                                onChange={this.handleChangeImporte}
                                min="0"
                            />
                        </div>
                    }

                    <div className="col-12 mt-2">
                        <div className="d-flex justify-content-center flex-wrap gap-2 align-items-center pt-3 border-top">
                            <div className="col-12 col-sm-auto text-center" hidden={!this.state.showSpinner}>
                                <MiniSpinner />
                            </div>
                            <button
                                type="submit"
                                disabled={this.state.showSpinner}
                                className="btn btn-sm background-rojo-megatone px-4"
                            >
                                Guardar
                            </button>
                            <button
                                type="button"
                                onClick={this.goBack}
                                className="btn btn-sm btn-light"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    idUsuario: state.general.userId,
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    settedSellerObject: state.general.generalObject,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    usuario: JSON.stringify(state.usuarios.user) != "{}" ? state.usuarios.user : "{}"
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuario
})(UserNew));